/**
 * The headless auth-bridge route, shared by the router and by the startup code
 * that must NOT run there.
 *
 * `/auth-bridge` is loaded in a hidden cross-site iframe by the embeddable
 * feedback widget. It is a read-only probe: it answers "does this browser have a
 * Brafton session authorized for this round?" and posts the answer back. It is
 * the same Angular application as the main app, so every root-level side effect
 * runs there too — which is wrong for a probe, and in two cases actively harmful:
 *
 *  - the session-cookie sync would CLEAR the signed-in user's cookie, because a
 *    framed instance has its own empty/partitioned storage and so reports "no
 *    token" (see core/brafton-session-cookie.ts)
 *  - auto-logout would redirect the iframe to Auth0's logout endpoint and end the
 *    session in the tab the user is actually working in (see app.ts)
 */
export const AUTH_BRIDGE_PATH = 'auth-bridge';

/** True when the given location is the auth-bridge page. */
export function isAuthBridgeLocation(location: Pick<Location, 'pathname'> | null | undefined): boolean {
  const pathname = location?.pathname ?? '';
  return pathname.replace(/\/+$/, '') === `/${AUTH_BRIDGE_PATH}`;
}
